import { render, staticRenderFns } from "./DadosTurma.vue?vue&type=template&id=2693db76&"
import script from "./DadosTurma.vue?vue&type=script&lang=js&"
export * from "./DadosTurma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports